import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../DesignSystem/colors';
const Wrapper = styled.div `
  transition: background 100ms;
  border-radius: 50%;
  flex-shrink: 0;
  svg {
    display: block;
  }
  ${(props) => props.hover &&
    css `
      &:hover {
        background: ${colors.background.backgroundTertiary};
      }
    `}
  ${(props) => props.transition &&
    `
  svg > * {
    transition: ${props.transition};
    transition-delay: 0.3s;
  }
`}
`;
function ImpIcon({ size = '24px', dataTestId = 'icon', hover = false, fill, height, width, padding, onClick, ariaLabel, iconSrc, stroke, strokeWidth, transition, underlineSize, }) {
    const role = onClick ? 'button' : undefined;
    const tabIndex = onClick ? 0 : undefined;
    const iconStyles = {
        display: 'block',
        cursor: onClick ? 'pointer' : 'inherit',
        height: height || size,
        width: width || size,
        padding: padding || 'auto',
        transition: transition || 'none',
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onClick && onClick({});
        }
    };
    if (typeof iconSrc === 'string') {
        return (React.createElement("img", { "data-testid": dataTestId, src: iconSrc, alt: ariaLabel || 'image', onClick: onClick, role: role, tabIndex: tabIndex, style: iconStyles }));
    }
    else if (typeof iconSrc === 'function') {
        const IconComponent = iconSrc;
        const IconElement = (React.createElement(Wrapper, { "data-testid": dataTestId, onClick: onClick, role: role, tabIndex: tabIndex, onKeyDown: handleKeyDown, style: iconStyles, "aria-label": ariaLabel, stroke: stroke, fill: fill, hover: hover, transition: transition },
            React.createElement(IconComponent, { stroke: stroke, strokeWidth: strokeWidth, width: size === null || size === void 0 ? void 0 : size.replace('px', ''), height: size.replace('px', '') })));
        switch (underlineSize) {
            case 'm':
                return (React.createElement("div", { style: { position: 'relative' } },
                    IconElement,
                    React.createElement("div", { style: {
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '10px',
                            height: '2px',
                            backgroundColor: stroke,
                        } })));
        }
        return IconElement;
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
export default ImpIcon;
//# sourceMappingURL=ImpIcon.js.map